// extracted by mini-css-extract-plugin
export default {"ball":"DotBall_ball__B2AR7","confirm":"DotBall_confirm__jrYEj","pending":"DotBall_pending__N33nj","cancelled":"DotBall_cancelled__Aub0G"};